import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $uibModalInstance, authService, tracking) {
  $scope.error = '';
  $scope.submitted = false;
  $scope.loading = false;
  $scope.emailSent = false;

  $scope.sendEmail = function(form) {
    $scope.submitted = true;

    if (form.$invalid) {
      $scope.error = 'Please enter a valid email';
      return;
    }

    authService.forgotPassword($scope.email, function() {
      $scope.submitted = false;
      $scope.emailSent = true;

      tracking.trackEvent(SEGMENT_EVENTS.ForgotPassword);

    }, function(resp) {
      $scope.error = resp.data.errors[0].message;
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'tl.auth.service',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/forgotPassword/forgotPasswordModalCtrl.js